import React, { FunctionComponent } from 'react';
import styles from './section-header.module.scss';
import { Text, ITextProps } from '../text/text';
import { Button, IButtonProps } from '../button/button';
import isEmpty from 'lodash/isEmpty';

export interface ISectionHeaderProps {
  header: ITextProps[];
  description: ITextProps[];
  button: IButtonProps[];
  buttonPosition: string;
}

export const SectionHeader: FunctionComponent<ISectionHeaderProps> = ({
  header,
  description,
  button,
  buttonPosition
}) => {
  return (
    <div className={`${styles.wrapper}`}>
      {!isEmpty(header) ? (
        <div className={styles.header}>
          {header.map((text: ITextProps, i) => (
            <Text {...text} key={i} />
          ))}
        </div>
      ) : null}
      {!isEmpty(description) ? (
        <div className={styles.description}>
          {description.map((text: ITextProps, i) => (
            <Text {...text} key={i} />
          ))}
        </div>
      ) : null}
      {!isEmpty(button) ? (
        <div
          style={{ justifyContent: buttonPosition }}
          className={styles.button}
        >
          {button.map((elem, i) => (
            <Button {...elem} key={i} />
          ))}
        </div>
      ) : null}
    </div>
  );
};
